import $api from '../services';

export default {
    createNote(params) {
        return $api.post('/user-notes', params);
    },
    updateNote(params, id) {
        return $api.put(`/user-notes/${id}`, params);
    },
    deleteNote(id) {
        return $api.delete(`/user-notes/${id}`);
    }
};
